module.exports = __webpack_public_path__ + "img/underline.3a2fe2cf.svg";